import React, { PureComponent } from "react";
import "./Navigation.scss";
import Classnames from "classnames";

import { SECTION_MAPPING, FOCUS } from "../../constants";
import { section } from "../../global-interfaces";

interface Props {
  setSection: Function;
  selectedSection: section;
  isMobile: boolean;
  isOpen: boolean;
  setNavStatus: Function;
}
interface State {}

class Navigation extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};

    this.toggleNav = this.toggleNav.bind(this);
  }

  toggleNav() {
    this.props.setNavStatus(!this.props.isOpen);
  }

  render() {
    const { isOpen, setNavStatus } = this.props;
    const { selectedSection, isMobile } = this.props;

    return (
      <div
        style={{gridTemplateRows: `repeat(${SECTION_MAPPING.length}, 1fr)`}}
        className={Classnames("Navigation", { isOpen })}
        tabIndex={0}
        onClick={this.toggleNav}
        onBlur={() => {
          // don't want to simply toggle, in iOS gets triggered by link copy
          setNavStatus(false);
        }}
        onMouseOver={isOpen || isMobile ? () => {} : this.toggleNav}
        onMouseOut={isOpen && !isMobile ? this.toggleNav : () => {}}
      >
        {// map over color tabs
        SECTION_MAPPING.map(d => (
          <div className="nav-tab-parent"
            key={d.title}
            onClick={() => isOpen && this.props.setSection(d)}>

            <div className={Classnames("nav-tab-back", d.color, selectedSection.title === d.title ? FOCUS : null)}></div>

            <div
              className={Classnames("nav-tab-front", d.color, selectedSection.title === d.title ? FOCUS : null)}
            >
              <img
                src={
                  process.env.PUBLIC_URL +
                  (selectedSection.title === d.title ? d.pathActive : d.path)
                }
              />
              <span> {d.title} </span> 
            </div>
            </div>
        ))}
      </div>
    );
  }
}

export default Navigation;
